 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","2":"default~modules-demoUniversity-module~modules-videos-videos-module","3":"bootstrap","5":"modules-aboutus-module","6":"modules-affiliates-module","7":"modules-aiediting-module","8":"modules-aimarketplace-module","9":"modules-apilandingpage-module","10":"modules-apilauchpage-module","11":"modules-brand-module","12":"modules-campus-ambassador-module","13":"modules-case-study-case-study-module","14":"modules-cdp-for-cyber-module","15":"modules-cdp-for-finance-module","16":"modules-cdp-for-legal-module","17":"modules-cdp-for-medical-module","18":"modules-cdp-module","19":"modules-cdp-security-module","20":"modules-citation-quality-check-module","21":"modules-citationsamplereport-module","22":"modules-contactus-module","23":"modules-datasecurity-module","24":"modules-demoUniversity-module","25":"modules-essaychecker-module","26":"modules-eu-ai-act-module","27":"modules-faq-module","28":"modules-freegrammarchecker-module","29":"modules-helpdesk-module","30":"modules-industry-engagements-industry-engagements-module","31":"modules-journal-finder-journal-finder-module","32":"modules-medicalsa-module","33":"modules-news-news-module","34":"modules-newsletters-module","35":"modules-paraphrasingapimodule","36":"modules-podcast-podcast-module","37":"modules-pricingV2-module","38":"modules-pricingV3-module","39":"modules-pricingV4-module","40":"modules-pricingV5-module","41":"modules-pricingV6-module","42":"modules-professional-editing-service-module","43":"modules-proofread-word-latex-module","44":"modules-proofreadingtools-module","45":"modules-thesischecker-module","46":"modules-trinka-ai-user-manual-module","47":"modules-trinkavsginger-module","48":"modules-trinkavsgptzero-module","49":"modules-trinkavsgrammarly-module","50":"modules-trinkavslanguage-module","51":"modules-trinkavsprowritingaid-module","52":"modules-trinkavsquillbot-module","53":"modules-trinkavswritefull-module","54":"modules-trinkavszerogpt-module","55":"modules-tryademo-module","56":"modules-user-manual-documark-module","57":"modules-videos-videos-module","58":"modules-webinars-webinars-module","59":"modules-whitepaper-whitepaper-module"}[chunkId]||chunkId) + "-es2015." + {"0":"c4abe7a7ce8cf15ed661","2":"9ed6fd97e7a92a053482","3":"c8589b3a1f58821b9262","5":"a811b1ba00329f87de93","6":"9af5d163b5ed0dfacd5e","7":"44e19f2ddb0b35d0b674","8":"db4d3d73083886af4ac8","9":"c4d337e55a938a233d89","10":"880dd92ddd17ab66fda0","11":"fe7a9ecd53aeb45eb8f8","12":"0f523e73cd50e762017b","13":"7f52d60e0430d173982b","14":"ebb81837106879ce7789","15":"f723b1996bf444754552","16":"66d6cd3ddc829fb600d0","17":"7bdc9e4d4adc4ba9857e","18":"a1c8ed5f39a072264c74","19":"9d634c2ca739a2a6cf31","20":"05c3fbe233c22295e1b0","21":"123005a70971110083b5","22":"9ceca657e422fcc65c3c","23":"76c72662f3663acdbb85","24":"a6210deb03490c467a0e","25":"754d58e8b82089ac71b5","26":"1420d4f41ab77c643938","27":"c4a541da1db28923dfc8","28":"916036f3d1b766abbf45","29":"d5b91e5cc720729ff09a","30":"9d7c91b1daef684c7ff7","31":"fe1338362bbb86522a9b","32":"3ee5f568e5cf2081e087","33":"0ecceaed3efd125bedb3","34":"64aa81c7a2a78e797c0a","35":"1027d98818019dfaf311","36":"7d1b230b11838aad7352","37":"ce1c573b4c520b593611","38":"23fb7f44da01c2f83720","39":"94267caf7db86fcf89a8","40":"c2b4319fffc79fc59a84","41":"3d109e2b4fd3cadf2051","42":"70ccbde789da3fab82a3","43":"b502dc4481e0d0e0cb1b","44":"1eed766de8f432081a4c","45":"eee1b5a580ae13ac8939","46":"f068e5b0c536a3bdf8e8","47":"e4c99cb2413a7f7662f0","48":"4f860f82067d07a64107","49":"bb89d0ad38cbf403cf61","50":"e92117febf5ac4478f7b","51":"51780e3ee9c7a3a04f6a","52":"51d5032b788c575bbbde","53":"654d916acf947ba5bc7f","54":"767d1e706289f97cb334","55":"dee3f0943c33f162c87a","56":"8245aa30c1365b21fa19","57":"64e2e503b305a44c8bb0","58":"110ed23f05a9074f4ced","59":"28cb870ceb2b3010ea43"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
